import Bridge from '@/utils/bridge.js'
export default {
  // 关闭当前webview
  closeView() {
    Bridge.callHandler('dataToNative', { type: 0 }, (responseData) => { })
  },
  // 关闭顶部导航
  hideTitleBar() {
    Bridge.callHandler('dataToNative', { type: 1 }, (responseData) => { })
  },
  // 刷新token
  getToken(callback = null) {
    Bridge.callHandler('dataToNative', { type: 2 }, (responseData) => {
      if (callback) {
        callback(responseData)
      }
    })
  },
  // 调用分享
  nativeShare(data = null, callback = null) {
    if (!data || typeof data != 'object') {
      console.warn('请传入正确的分享数据')
      return
    }
    Bridge.callHandler('dataToNative', { type: 3, data }, (responseData) => {
      if (callback) {
        callback(responseData)
      }
    })
  },
  // 跳转原生页面
  gotoNativePage(data = null, callback = null) {
    if (!data || typeof data != 'object') {
      console.warn('请传入正确的数据')
      return
    }
    Bridge.callHandler('dataToNative', { type: 4, data }, (responseData) => {
      if (callback) {
        callback(JSON.parse(responseData))
      }
    })
  },
  // 获取app基础信息 版本号appVersion、牛数uuid
  getAppInfo(callback = null) {
    return new Promise((resolve) => {
      Bridge.callHandler('dataToNative', { type: 5 }, (responseData) => {
        if (callback) {
          callback(JSON.parse(responseData))
        }
        resolve(JSON.parse(responseData))
      })
    })
  },
  // 调用客户端支付
  nativePay(data = null, callback = null) {
    if (!data || typeof data != 'object') {
      console.warn('请传入正确的数据')
      return
    }
    return new Promise((resolve) => {
      Bridge.callHandler('dataToNative', { type: 6, data }, (responseData) => {
        if (callback) {
          callback(JSON.parse(responseData))
        }
        resolve(JSON.parse(responseData))
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/plugins/bridgeFunc.js